// backend.jsx
//export const BASE_URL = "https://69.62.72.147:8090";
//export const BASE_URL = "https://localhost:8090";
export const BASE_URL = "https://girrajmedicare-1.onrender.com";


